<template>
    <div id="page" class="page">

      <input type="text" hidden :value="recup_id(id)">



        <interne_menu></interne_menu>

        <section id="download-4" class="bg-fixed p-top-160 pro_m download-section division ">
            <div class="container">
                <div class="row">

                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">
                        <div class="download-txt" >


                              <div class="d_pic"><img :src="'https://carte.abidjan.net/images/img_partenaire/' + privilege.img1" class="img_card"></div>


                            <!-- Title -->
                            <h2 class="h2-xs nom_loc"> {{ privilege.nom }} </h2>
                              <div class="category"><a href="" class="cat" >{{privilege.categorie}}</a></div>
                            <!-- Text -->
                            <p class="p-lg" v-html="privilege.description" ></p>


                        </div>
                    </div>	 <!-- END DOWNLOAD TEXT -->


                </div>	  <!-- End row -->


                  <div class="row mt-30 mt-row">
                            <div class="col-md-3 col-sm-6">
                                <div class="box15">
                                    <img class="pic-1" :src="'https://carte.abidjan.net/images/img_partenaire/' + privilege.img2 ">

                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <div class="box15">
                                    <img class="pic-1" :src="'https://carte.abidjan.net/images/img_partenaire/' + privilege.img3">

                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <div class="box15">
                                    <img class="pic-1" :src="'https://carte.abidjan.net/images/img_partenaire/' + privilege.img4">

                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <div class="box15">
                                    <img class="pic-1" :src="'https://carte.abidjan.net/images/img_partenaire/' + privilege.img5">

                                </div>
                            </div>
                  </div>


            </div>	   <!-- End container -->
        </section>


        <!-- Ma carte virtuelle -->
        <section id="pro" class="bg-scroll wide-60 h_1 content-section division sct_bck pro_part  sub_section ">
            <div class="container">


            <div class="row">
                  <div class="col-lg-12 col-xl-12 ">
                    <div class="row">


                      <!-- PRICE PLAN FREE -->
                      <div class="col-md-6 " data-animation="fadeInRight" data-animation-delay="400">
                        <div class="pricing-table m-bottom-20">

                          <!-- Plan Price  -->
                          <div class="pricing-plan m-bottom-10">
                            <h4 class="h4-md"><font-awesome-icon icon="fa-solid fa-info h_icon" /> <font-awesome-icon icon="fa-solid fa-circle-info" /> <span>Informations</span></h4>
                          </div>

                          <h5 class="h5-md animated fadeInRight visible info_cont" data-animation="fadeInRight" data-animation-delay="500">Services </h5>
                          <p v-html="privilege.service"></p>

                          <h5 class="h5-md animated fadeInRight visible info_cont" data-animation="fadeInRight" data-animation-delay="500">Catégorie </h5>
                          <p>{{privilege.categorie}}</p>

                          <h5 class="h5-md animated fadeInRight visible info_cont" data-animation="fadeInRight" data-animation-delay="500" >Localisation </h5>
                          <p v-html="privilege.localisation"></p>

                          <h5 class="h5-md animated fadeInRight visible info_cont" data-animation="fadeInRight" data-animation-delay="500">Contacts </h5>
                          <p v-html="privilege.contact"></p>
                          <p v-html="privilege.email"></p>
                          <p ><a :href="'http://'+privilege.website" target="_blank">{{privilege.website}}</a></p>



                        </div>

                        <div class="pricing-table m-bottom-20">
                                  <!-- Plan Price  -->
                                  <div class="pricing-plan m-bottom-10">
                                    <h4 class="h4-md"><font-awesome-icon icon="fa-solid fa-gift " /> <span>Nos Offres</span></h4>
                                  </div>
                                  <!-- Pricing Plan Features  -->
                                <p v-html="renderHTML(privilege.remise, privilege.designation )"></p>
                        </div>

                        <div class="pricing-table m-bottom-20">

                                  <!-- Plan Price  -->
                                  <div class="pricing-plan m-bottom-10">
                                    <h4 class="h4-md"><font-awesome-icon icon="fa-solid fa-file " /> <span>Description</span></h4>
                                  </div>

                                  <p v-html="privilege.description"></p>

                        </div>

                      </div>	<!-- END PRICE PLAN FREE -->


                      <!-- PRICE PLAN PRO -->
                      <div class="col-md-6 " data-animation="fadeInLeft" data-animation-delay="400">
                        <div class="pricing-table m-bottom-20">

                          <!-- Plan Price  -->
                          <div class="pricing-plan m-bottom-10">
                            <h4 class="h4-md"><font-awesome-icon icon="fa-solid fa-qrcode " /> <span>Paiement sans contact</span></h4>
                            <p><img src="https://carte.abidjan.net/images/img_partenaire/QR-cd-bg-New1.jpg" class="img-QR1"></p>
                          </div>

                          <a href="https://bit.ly/3szWFfm" target="_blank" class="btn btn-lightorange">DEVENEZ MARCHAND APAYM PRO</a>

                        </div>
                      </div>	<!-- END PRICE PLAN PRO -->


                    </div>

                  </div>
                  </div>

                    <div class="row">
                        <div class="col-lg-12 col-xl-12 ">
                            <div class="pricing-table m-bottom-20 tb2">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3972.5526945310335!2d-4.0024464842035306!3d5.332231196131949!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1eb47944c0395%3A0xbfae134df6015c32!2sAgence%20Weblogy%20Cocody!5e0!3m2!1sfr!2sci!4v1675340302915!5m2!1sfr!2sci" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>

                        <div class="col-lg-12 col-xl-12 ">

                            <GMap :center="center" :zoom="zoom">
                            <GMarker :position="center" :icon="'mapMaker.png'" :title="'Siège Weblogy'" />
                            </GMap>

                          </div>


                    </div>

            </div>	   <!-- End container -->
        </section>
        <!-- END Ma carte virtuelle -->
        <footer_menu></footer_menu>

    </div>



</template>


<script>

import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
import axios from 'axios';



export default{


  props: ['id'],
  data(){

    return{
      reponse: "",

      privilege: {
        nom: "",
        categorie: "",
        remise: "",
        designation: "",
        services: "",
        contact: "",
        website: "",
        email: "",
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: ""
      },

      catego: {
        nom: "",
      }
    }


  },


  methods:{

    recup_id(id){

      const slug = id;
      const id_rec = slug.split('-')[slug.split('-').length - 1];
      //console.log(id_rec); // Output: '197'

      this.reponse = id_rec;
      return id_rec;
    },

    // add two paramater in v-html
    renderHTML(remise, designation) {
      return `${remise} ${designation}`
    },

    //seeting function api

    getPrivilege(){
                var dataSend = new FormData() ;
                dataSend.append("id", this.reponse);

                axios.post("https://carte.abidjan.net/assets-apaym/privilege_detail.php",
                    dataSend
                ).then((res)=> {
                    //console.log(res.data)
                    this.privilege.nom = res.data.nom ;
                    // this.privilege.categorie = res.data.categorie ;
                    this.getCategoriePrivilege(res.data.categorie);
                    this.getOffresPrivileges(this.reponse);
                    this.privilege.service = res.data.service ;
                    this.privilege.description = res.data.description;
                    this.privilege.localisation = res.data.localisation ;
                    this.privilege.contact = res.data.contact ;
                    this.privilege.email = res.data.email ;
                    this.privilege.website = res.data.website ;

                    this.privilege.img1 = res.data.img1 ;
                    this.privilege.img2 = res.data.img2 ;
                    this.privilege.img3 = res.data.img3 ;
                    this.privilege.img4 = res.data.img4 ;
                    this.privilege.img5 = res.data.img5 ;


                }).catch(error => {
                    console.log(error)
                })
            },

            getCategoriePrivilege(id){
                var dataSend = new FormData() ;
                dataSend.append("id", id);

                axios.post("https://carte.abidjan.net/assets-apaym/categorie_privilege.php",
                    dataSend
                ).then((res)=> {
                    this.privilege.categorie = res.data.nom ;
                }).catch(error => {
                    console.log(error)
                })
            },

            getOffresPrivileges(id){
                var dataSend = new FormData() ;
                dataSend.append("id", id);

                axios.post("https://carte.abidjan.net/assets-apaym/details_offres.php",
                    dataSend
                ).then((res)=> {
                  console.log(res)
                    this.privilege.remise = res.data.remise ;
                    this.privilege.designation = res.data.designation ;
                }).catch(error => {
                    console.log(error)
                })
            }

  },

  name :'privileges-details',

    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu,
    } ,

    mounted(){
      //console.log(this.$route.params.slug);

      this.getPrivilege() ;

    },



}
</script>



<style scoped>



.btn-lightorange {
    background: #FF9E00;
    width: 100%;
    border-radius: 19px;
    border: none;

}
.pricing-table {
 padding: 40px;
}
.tb2 {
 padding: 10px !important;
}
.info_cont{
  color: #261b64;
}
.mt-row{
  margin-bottom: 30px;
}

.pricing-table {
    background-color: #fff;
    border: 1px solid #f1efef !important;
}

.pricing-plan h4 span {
    color: #FF9E01;
    font-weight: 500 !important;
}
.img-QR1, .img-QR2 {
    width: 100%;
    height: auto;

}

.cat{
  font-weight: 400;
}
.category{
  background: #f4f4f4;
    color: #fff;
    width: 300px;
    padding: 7px;
    border-radius: 20px;
    margin: auto;
}
.nom_loc{
  line-height: 0.57143rem;
  margin-bottom: 25px;

}
.d_pic{
  width: 200px;
  height: 200px;
  background: grey;
  margin: auto;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom:30px;
  border: 1px solid #efefef;
}
.img_card{
  max-width: 210px !important;
}
.wide-60 {
    padding-top: 60px !important;
    padding-bottom: 60px;
}
.row_func{
  padding-top: 80px;
}
.img-choice{
    max-width: 100px;
    width: 100%;
}
.p-lg{
  margin-top: 20px !important;
}
.fbox-3 {
    width: 240px;
    height: 240px;
    position: relative;
    text-align: center;
    background-color: #fff;
    border: 1px solid #f1f1f2;

    border-radius: 50%;
    padding: 30px 30px;
    margin-bottom: 30px;
    transition: all 300ms ease-in-out;
    margin: auto;
    margin-bottom: 30px;
}

.box-texte{
border: 1px solid;
padding: 10px;
border-radius: 10px;
background: linear-gradient(73deg,#392b89,#261b64);
/*background: #261b64;*/
}
.p_text{
  margin: 0;
    margin-bottom: 0.2rem;
    padding: 0;
}

.h5_title{
margin-bottom: 0.51429rem !important;
color: orange;
}


.blue-icon span {
    background: -webkit-gradient(linear, left top, left bottom, from(#5f4ad8), to(#261b64));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.fbox-1 {
     text-align: left;
    margin-bottom: 17px;
}

.sub_section {
   background: #f6f6f6;
    padding-top: 30px!important;
    padding-bottom: 60px!important;
}
.btn-lightorange-left {
    background: #FF9E00;
    max-width: 300px !important;
    width: 100%;
    border-radius: 19px !important;
    border: none !important;
    margin-left: 0 !important;
}


.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}

h2.h2-xs {
    font-size: 4.25rem !important;
}

#download-4 p {
     padding: 0 0% !important;
}



.pro_m{
    background-image: url(@/assets/images/map-bg.png);
    background-size: auto;
}
h2.h2-xs {
    font-size: 2.6rem !important;
}


@media screen and (max-width: 767px) {
  .d_pic{
      margin-top: 50px;
  }

  .s_tarif{
    padding-top: 40px;
  }

  .row_func{
    padding-top: 20px;
  }

  h5.h5-md {
        font-size: 0.9rem;
    }

    .pro_m{
    background-image: url(@/assets/images/map-bg.png);
    padding-top: 30px !important;
}

.p-top-160 {
    padding-top: 100px;
}
.nom_loc{

    line-height: 1.1 !important;
}



.wide-60 {
    padding-top: 0px !important;
    padding-bottom: 60px;
}

}


h2.h2-lg {
    font-size: 3.75rem !important;
}

.box15{position:relative}
.box15 img{width:100%;height:auto}
.box15 .box-content{width:100%;height:100%;position:absolute;top:0;left:0;transition:all .5s ease 0s}
.box15:hover .box-content{background-color:rgba(255,242,242,.8)}
.box15 .box-content:after,.box15 .box-content:before{content:"";width:50px;height:50px;position:absolute;opacity:0;transform:scale(1.5);transition:all .6s ease .3s}
.box15 .box-content:before{border-left:1px solid #040404;border-top:1px solid #040404;top:19px;left:19px}
.box15 .box-content:after{border-bottom:1px solid #040404;border-right:1px solid #040404;bottom:19px;right:19px}
.box15:hover .box-content:after,.box15:hover .box-content:before{opacity:1;transform:scale(1)}
.box15 .title{font-size:22px;color:#000;margin:0;position:relative;top:0;opacity:0;transition:all 1s ease 10ms}
.box15:hover .title{top:39%;opacity:1;transition:all .5s cubic-bezier(1,-.53,.405,1.425) 10ms}
.box15 .title:after{content:"";width:0;height:1px;background:#040404;position:absolute;bottom:-8px;left:0;right:0;margin:0 auto;transition:all 1s ease 0s}
.box15:hover .title:after{width:80%;transition:all 1s ease .8s}
.box15 .icon{width:100%;margin:0 auto;position:absolute;bottom:0;opacity:0;transition-duration:.6s;transition-timing-function:cubic-bezier(1,-.53,.405,1.425);transition-delay:.1s}
.box15:hover .icon{bottom:39%;opacity:1}
.box15 .icon li{display:inline-block}
.box15 .icon li a{display:block;width:40px;height:40px;line-height:40px;border-radius:50%;font-size:18px;color:#000;border:1px solid #000;margin-right:5px;transition:all .3s ease-in-out 0s}
.box15 .icon li a:hover{background:#000;color:#fff}
@media only screen and (max-width:990px){.box15{margin-bottom:30px}
}






</style>

